import React from 'react';

const StudentPortalTabHeader = ({ icon, title, subtitle, actions }) => (
  <header className="sp-tab-header">
    <div className="sp-tab-header__main">
      {icon && <div className="sp-tab-header__icon">{icon}</div>}
      <div>
        <h2 className="sp-tab-header__title">{title}</h2>
        {subtitle && <p className="sp-tab-header__subtitle">{subtitle}</p>}
      </div>
    </div>
    {actions && <div className="sp-tab-header__actions">{actions}</div>}
  </header>
);

export default StudentPortalTabHeader;